export default "__VITE_ASSET__DrxrRNZa__"